import { FunctionComponent } from 'react';
import styles from './SearchNotFound.module.scss';
import clsx from 'clsx';

interface SearchNotFoundProps {
    className?: string;
}

export const SearchNotFound: FunctionComponent<SearchNotFoundProps> = props => {
    return (
        <div className={clsx(styles.container, props.className)}>
            <span className={styles.title}>Oops! No result found</span>
            <span className={styles.description}>
                What you search was unfortunately not found or doesn&apos;t exist, try to find something else.
            </span>
        </div>
    );
};

export default SearchNotFound;
